import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import hdk from '@/lib/hdk';
import setter from '@/lib/setter';
import userApi from '@/api/userApi';

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (hdk.data(setter.tokenName)) {
            next();
        }
    } else {
        if ('/login' === to.path && to.query['organCode'] && to.query['code'] && to.query['state']) {
            next({
                replace: true
            });
            const organCode = to.query['organCode'],
                code = to.query['code'],
                state = to.query['state'];
            console.log(111111)    
            userApi.login(code, state).then(res => {
                const headers = res.headers,
                    data = res.data;
                
                hdk.data({
                    key: setter.organInfo,
                    value: {organCode}
                });
                  
                hdk.data({
                    key: setter.tokenName,
                    value: headers[setter.tokenName]
                });
                
                hdk.data({
                    key: setter.userInfo,
                    value: {
                        ...data
                    }
                });
                next({
                    path: '/index',
                    replace: true
                });
            }).catch(() => {

            });
        } else {
            next();
        }
    }
});

export default router